import React from "react"
import { Navigate } from "react-router-dom"
import { useAuth } from "context/AuthContext"

export default function LandingPage() {
  const { isAuthenticated } = useAuth()

  return (
    isAuthenticated ? <Navigate to="/feed"/> : <Navigate to="/login"/>
  )
}
